import Vue from 'vue'

export default {
    set: key => (state, val) => {
        state[key] = val
    },
    setMap: (obj) => (state, { key, val }) => {
        if (!state[obj][key]) {
            Vue.set(state[obj], key, val)
        } else {
            state[obj][key] = val
        }
    },
    load: (key, mutationKey, apiFunction, mapFunction = null) => async ({ commit, state }, forceUpdate = false) => {
        if (!state.loading[key] && (!!forceUpdate || !state[key] || (Array.isArray(state[key]) && state[key].length === 0))) {
            state.loading[key] = true
            try {
                let response = await apiFunction()
                let result = response.data
                if (mapFunction) {
                    result = response.data.map(mapFunction)
                }
                commit(mutationKey, result)
            } finally {
                state.loading[key] = false
            }
        }
    },
    loadById: (obj, mutationKey, apiFunction) => async ({ commit, state }, id) => {
        if (!state.loading[obj][id] && !state[obj][id]) {
            Vue.set(state.loading[obj], id, true)
            try {
                let response = await apiFunction(id)
                //  Deve essere di tipo 'setMap'
                commit(mutationKey, { key: id, val: response.data })
            } finally {
                state.loading[obj][id] = false
            }
        }
    }
}
